import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import Twitter from '@mui/icons-material/Twitter';
import YouTube from '@mui/icons-material/YouTube';
import { Grid, Link } from '@mui/material';
import React from 'react';

export const SocialBar = () => {
  return (
    <Grid container justifyContent="flex-end" columnSpacing="1em">
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://www.facebook.com/Jungheinrich/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Facebook sx={{ fontSize: 30 }} />
        </Link>
      </Grid>
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://www.linkedin.com/company/jungheinrich-ag"
          target="_blank"
          rel="noreferrer noopener"
        >
          <LinkedIn sx={{ fontSize: 30 }} />
        </Link>
      </Grid>
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://twitter.com/JungheinrichAG"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Twitter sx={{ fontSize: 30 }} />
        </Link>
      </Grid>
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://www.youtube.com/JungheinrichAG"
          target="_blank"
          rel="noreferrer noopener"
        >
          <YouTube sx={{ fontSize: 30 }} />
        </Link>
      </Grid>
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://www.instagram.com/jungheinrich/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Instagram sx={{ fontSize: 30 }} />
        </Link>
      </Grid>
      <Grid item>
        <Link
          color="#FFF"
          underline="hover"
          href="https://www.xing.com/company/jungheinrichag"
          target="_blank"
          rel="noreferrer noopener"
        >
          <img
            alt="XING Icon"
            style={{ paddingTop: 4 }}
            height="25em"
            src="https://media-live3.prod.scw.jungheinrichcloud.com/germany/images/Logos/xing-social-logo.png"
          />
        </Link>
      </Grid>
    </Grid>
  );
};
